import { useEffect, useState } from "react";
import { History, ChevronDown } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export const OfferHistory = () => {
  const { t, lang } = useLang();
  const h = t.dash.offerHistory;
  const [entries, setEntries] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/offers/history").then((r) => setEntries(r.data)).catch(() => {});
  }, []);

  if (!entries.length) return null;
  const fmtVal = (v) => (v === true ? h.on : v === false ? h.off : v === "" || v == null ? "—" : String(v));

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8" data-testid="offer-history-panel">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="offer-history-toggle"
        className="w-full flex items-center justify-between gap-3"
      >
        <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40">
          <History className="w-4 h-4 text-[#FF7900]" /> {h.title}
          <span className="text-white/25 normal-case tracking-normal">({entries.length})</span>
        </span>
        <ChevronDown className={`w-4 h-4 text-white/40 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-5 space-y-4 max-h-96 overflow-y-auto pr-2" data-testid="offer-history-list">
          {entries.map((e) => (
            <div key={e.id} className="border-l-2 border-white/10 pl-4" data-testid={`offer-history-entry-${e.id}`}>
              <p className="text-xs">
                <span className="font-semibold text-white/85">{e.offer_name}</span>
                <span className={`ml-2 ${e.action === "deleted" ? "text-red-400" : e.action === "created" ? "text-emerald-400" : "text-[#FF7900]"}`}>
                  {h[e.action]}
                </span>
                <span className="text-white/30 ml-2">
                  {new Date(e.at).toLocaleString(lang === "fr" ? "fr-BE" : "en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
                </span>
              </p>
              {e.changes.map((c, i) => (
                <p key={i} className="text-xs text-white/50 mt-1">
                  <span className="text-white/35">{h.fields[c.field] || c.field} :</span>{" "}
                  <span className="line-through text-white/30">{fmtVal(c.old)}</span>
                  <span className="mx-1.5 text-[#FF7900]">→</span>
                  <span className="text-white/75">{fmtVal(c.new)}</span>
                </p>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
